import { IPrijavnica, ISeminarNak, ISeminarNakAvailability, ISeminarSS } from './../model/index';
import axios, { AxiosResponse, AxiosPromise } from 'axios';
import { IEnotaZrss } from '@/model';


const baseAddress = process.env.VUE_APP_BASE_API_URL;


export function GetEnoteZrss(): AxiosPromise<IEnotaZrss[]> {
    return axios.get(`${baseAddress}/EnoteZrss`);
}

export function PostGetToken(username: string, password: string): AxiosPromise<string> {
    const bodyFormData = new FormData();

    bodyFormData.append('username', username);
    bodyFormData.append('password', password);

    return axios.post(`${baseAddress}/auth`, {username, password});
}


export function PostPrijavnica(prijavnica: any): AxiosPromise<IEnotaZrss[]> {
    return axios.post(`${baseAddress}/prijavnice`, JSON.stringify(prijavnica));
}
export function PostPrijavnicaStudijske(prijavnica: any): AxiosPromise<IEnotaZrss[]> {
    return axios.post(`${baseAddress}/prijavnicess/`, JSON.stringify(prijavnica));
}
export function PostPrijavnicaNak(prijavnica: any): AxiosPromise {
    return axios.post(`${baseAddress}/prijavnicenak/`, JSON.stringify(prijavnica));
}
export function PostPrijavnicaVp(prijavnica: any): AxiosPromise {
    return axios.post(`${baseAddress}/PrijavniceVp2021/`, JSON.stringify(prijavnica));
}
export function PostPrijavnicaTm(prijavnica: any): AxiosPromise {
    return axios.post(`${baseAddress}/PrijavniceTm2021/`, JSON.stringify(prijavnica));
}




export function GetSeminarjiStudijske(nivo: string): AxiosPromise<ISeminarSS[]> {
    return axios.get(`${baseAddress}/prijavnicess/seminarji/${nivo}`);
}

export function GetPrijavniceList(token: string): AxiosPromise<IPrijavnica[]> {
    return axios.get(`${baseAddress}/prijavnice`, { headers: { authorization: 'Bearer ' + token } });
}

export function DownloadExcel(token: string): AxiosPromise<Blob> {
    return axios.get(`${baseAddress}/prijavnice/excel`, {  responseType: 'blob',   headers: { authorization: 'Bearer ' + token, } });
}

export function GetSeminarjiNak(): AxiosPromise<ISeminarNakAvailability[]> {
    return axios.get(`${baseAddress}/prijavnicenak/seminarji`);
}


export function GetSeminarjiVp(): AxiosPromise<ISeminarNakAvailability[]> {
    return axios.get(`${baseAddress}/PrijavniceVp2021/seminarji`);
}
export function GetSeminarjiTm(): AxiosPromise<ISeminarNakAvailability[]> {
    return axios.get(`${baseAddress}/PrijavniceTm2021/seminarji`);
}